import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { inject } from '@vercel/analytics';
import { injectSpeedInsights } from '@vercel/speed-insights';
import { initAgentation } from './app/agentation-loader';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

Sentry.init({
  environment: environment.production ? 'production' : 'development',
  dsn: 'https://5e53eeb24638ae8188832bd7ad51deac@o4508795717419008.ingest.de.sentry.io/4508795719188560',
  integrations: [Sentry.browserTracingIntegration()],

  tracesSampleRate: environment.production ? 0.2 : 1.0,
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    },
    httpBodies: [],
    urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false },
  },
  // Only propagate tracing headers to our own backend. A broad "localhost"
  // target would also decorate requests to other local services (e.g. the
  // Agentation dev server on :4747) whose CORS rules reject sentry-trace.
  tracePropagationTargets: [new RegExp(`^${environment.SUPABASE_URL}`)],
});

inject();
injectSpeedInsights();
void initAgentation();
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
